
module.exports = ['arrow-down', 'arrow', 'campaign', 'card', 'check', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'drag', 'filter', 'google', 'graph', 'heart-filled', 'heart', 'info', 'link', 'menu', 'more', 'plus', 'receipt', 'remove', 'stacked-menu', 'star-filled', 'star', 'user', 'x']
    